.timer-visibility {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  min-height: 36px;
  padding: 6px 9px;
  border-radius: 8px;
}
.timer-visibility .ui-icon {
  width: 16px;
  height: 16px;
}
.timer-visibility:hover {
  background: #00000006;
}
.pomodoro-art {
  display: block;
  width: 126px;
  height: 126px;
  margin: auto;
}
html:has(> .floating-timer-body),
.floating-timer-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.floating-timer-body {
  margin: 0;
  background: var(--theme-shell-surface);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.floating-timer-body * {
  box-sizing: border-box;
}
.floating-timer {
  display: grid;
  grid-template-areas: "head" "stage" "controls" "footer";
  grid-template-rows: 22px minmax(0, 1fr) 28px auto;
  gap: 4px;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 6px 8px 9px;
  position: relative;
  overflow: hidden;
}
.floating-timer button {
  font: inherit;
  cursor: pointer;
  -webkit-app-region: no-drag;
}
.floating-timer button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}
.floating-timer .ui-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.floating-timer-head {
  grid-area: head;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  min-width: 0;
}
.floating-brand {
  font-size: 11px;
  font-weight: 650;
  letter-spacing: -0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.floating-brand > span {
  font-size: 9px;
  font-weight: 400;
  color: var(--muted);
  letter-spacing: 0;
}
.floating-head-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.floating-head-actions button {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 5px;
  color: var(--night-secondary);
  background: transparent;
}
.floating-head-actions button:hover {
  background: rgb(var(--theme-rgb) / 0.071);
  color: var(--text);
}
.floating-timer-stage {
  grid-area: stage;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 0;
}
.floating-sculpture {
  display: none;
  flex-shrink: 0;
}
.floating-sculpture .pomodoro-art {
  width: min(58px, 24vw, 32vh);
  height: min(58px, 24vw, 32vh);
  margin: 0;
}
.floating-face {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  container-type: size;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}
.floating-time {
  display: block;
  flex-shrink: 0;
  font-size: min(42px, 27cqw, 70cqh);
  line-height: 1;
  font-weight: 400;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.floating-phase {
  max-width: 100%;
  margin-top: 4px;
  font-size: 8px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.floating-controls {
  grid-area: controls;
  display: flex;
  gap: 5px;
  align-items: center;
  min-width: 0;
}
.floating-controls button {
  height: 28px;
  padding: 0;
  border: 1px solid rgb(var(--theme-rgb) / 0.125);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 550;
}
.floating-play {
  background: var(--night-emphasis);
  color: var(--night-ink);
  flex: 1;
  min-width: 0;
}
.floating-play:hover {
  background: var(--theme-action-hover);
}
.floating-play span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.floating-reset,
.floating-mini-size {
  background: transparent;
  color: var(--night-secondary);
  width: 28px;
  flex-shrink: 0;
  position: relative;
}
.floating-reset:hover,
.floating-mini-size:hover {
  background: rgb(var(--theme-rgb) / 0.051);
}
.floating-controls .floating-mini-size {
  display: none;
}
.floating-footer {
  grid-area: footer;
  display: none;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  font-size: 10px;
  line-height: 15px;
  color: var(--muted);
  padding-top: 5px;
  border-top: 1px solid rgb(var(--theme-rgb) / 0.086);
}
.floating-footer span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.floating-progress-track {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 3px;
  height: 2px;
  background: rgb(var(--theme-rgb) / 0.075);
  border-radius: 2px;
  overflow: hidden;
}
.floating-progress-fill {
  display: block;
  height: 100%;
  background: var(--night-emphasis);
  border-radius: 2px;
}
@media (min-width: 220px) and (min-height: 150px) {
  .floating-timer.expanded .floating-sculpture {
    display: block;
  }
  .floating-timer.expanded .floating-footer {
    display: flex;
  }
}
@media (max-width: 220px) {
  .floating-brand > span,
  .floating-play span {
    display: none;
  }
}
@media (max-height: 130px) {
  .floating-phase {
    display: none;
  }
}
/* A short window becomes a single strip. Secondary elements give way before
   the countdown can be clipped, including after manual window resizing. */
@media (max-height: 105px) {
  .floating-timer {
    grid-template-areas: "stage controls";
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: minmax(0, 1fr);
    gap: 8px;
    padding: 5px 8px 8px;
  }
  .floating-timer-head,
  .floating-sculpture,
  .floating-phase,
  .floating-footer,
  .floating-controls .floating-reset,
  .floating-controls .floating-noise,
  .floating-play span {
    display: none;
  }
  .floating-time {
    font-size: min(38px, 27cqw, 85cqh);
  }
  .floating-controls .floating-mini-size {
    display: flex;
  }
  .floating-controls .floating-play {
    width: 28px;
    flex: none;
  }
}
@media (max-width: 180px) and (max-height: 105px) {
  .floating-controls .floating-mini-size {
    display: none;
  }
}
@media (max-width: 130px), (max-height: 38px) {
  .floating-timer {
    grid-template-areas: "stage";
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: 0;
    padding: 2px 4px 5px;
  }
  .floating-timer-head,
  .floating-phase,
  .floating-sculpture,
  .floating-controls,
  .floating-footer {
    display: none;
  }
  .floating-time {
    font-size: min(42px, 27cqw, 85cqh);
  }
}
